import { render, staticRenderFns } from "./ReferenceLookupSection.vue?vue&type=template&id=bf05b51a&scoped=true"
import script from "./ReferenceLookupSection.vue?vue&type=script&lang=js"
export * from "./ReferenceLookupSection.vue?vue&type=script&lang=js"
import style0 from "./ReferenceLookupSection.vue?vue&type=style&index=0&id=bf05b51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf05b51a",
  null
  
)

export default component.exports